/**
 * Isolated set logos (`public/set-logos`). Paths are app-root relative for Vite.
 * Name fallbacks cover API-provided labels for newer sets before their codes are
 * added to the local fallback taxonomy.
 */
export const SET_LOGO_BY_CODE: Record<string, string> = {
  ARC: '/set-logos/arcane.webp',
  OGN: '/set-logos/origins.webp',
  OGS: '/set-logos/proving-grounds.webp',
  RAD: '/set-logos/radiance.webp',
  RDN: '/set-logos/radiance.webp',
  SFD: '/set-logos/spiritforged.webp',
  UNL: '/set-logos/unleashed.webp',
  VEN: '/set-logos/vendetta.webp',
  VND: '/set-logos/vendetta.webp',
  LGC: '/set-logos/legacy.webp',
  REC: '/set-logos/reckoning.webp',
};

const SET_LOGO_BY_NAME: Record<string, string> = {
  arcane: '/set-logos/arcane.webp',
  origins: '/set-logos/origins.webp',
  'proving grounds': '/set-logos/proving-grounds.webp',
  radiance: '/set-logos/radiance.webp',
  spiritforged: '/set-logos/spiritforged.webp',
  unleashed: '/set-logos/unleashed.webp',
  vendetta: '/set-logos/vendetta.webp',
  legacy: '/set-logos/legacy.webp',
  reckoning: '/set-logos/reckoning.webp',
  'the reckoning': '/set-logos/reckoning.webp',
};

function normLogoLookup(value: string | undefined): string {
  return (value ?? '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
}

export function setLogoUrl(
  setCode: string | undefined,
  setName?: string | undefined,
): string | undefined {
  const byCode = setCode?.trim() ? SET_LOGO_BY_CODE[setCode.trim().toUpperCase()] : undefined;
  if (byCode) return byCode;

  const normalizedName = normLogoLookup(setName);
  return Object.entries(SET_LOGO_BY_NAME).find(([name]) => normalizedName.includes(name))?.[1];
}
